document.addEventListener('alpine:init', () => {
    Alpine.data('sectionScene', () => ({
        calculateSlope() {
            this.s = (Math.atan(2 * this.h1 / this.b1) * 180 / Math.PI).toFixed(2);
        },

        calculateH1() {
            this.h1 = (Math.tan(this.s * Math.PI / 180) * this.b1 * 0.5 ).toFixed(2);
        },

        calculateB3() {
            this.b3 = (this.b1 - 2 * this.b4).toFixed(2);
        },

        calculateB4() {
            this.b4 = ((this.b1 - this.b3) / 2).toFixed(2);
        },

        purlinModelInitialized: false,

        getSectionModel() {
            return window.WBApp.utils.getSectionModel(
                this.roofType,
                this.collarSupport,
                this.midPurlinSupport,
                +this.b1,
                +this.b2,
                +this.b3,
                +this.b4,
                +this.h1,
                +this.h2,
                +this.s
            );
        },

        updateSectionScene() {
            this.sectionViewer.loadModel(this.getSectionModel());
        },

        init() {
            const canvas = document.getElementById('roof-section-scene');
            this.sectionViewer = new window.WBApp.utils.Viewer( canvas );
            this.sectionViewer.config.updateSettings(
                {
                    showGrid: false,
                    showOrigin: false,
                    showNodeLabels: false,
                    showMemberLabels: false,
                }
            );
            setTimeout(() => {
                const model = this.getSectionModel();
                this.sectionViewer.loadModel(model);
            }, 1000);
            this.$watch('roofType', () => {
                this.updateSectionScene();
            });
        },
    }));
});